import { render } from "./SocialCampaigns.vue?vue&type=template&id=b3421684&scoped=true"
import script from "./SocialCampaigns.vue?vue&type=script&lang=js"
export * from "./SocialCampaigns.vue?vue&type=script&lang=js"

import "./SocialCampaigns.vue?vue&type=style&index=0&id=b3421684&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3421684"]])

export default __exports__